import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Label from '@components/Label';
import Button from '@components/Button';
import { toNumber } from 'lodash';
import {
  Root,
  ListItem,
  ListItemTop,
  Radio,
  ListItemName,
  ListItemDescription,
  ListItemOption,
  ListItemRight,
  Label as LabelClass,
  ListItemSelected,
  BigTextSelected,
  HideOptionsWhenSelected,
  HasSelectedItem,
  ChangeSelectionButton,
  DisabledProduct,
} from './PriceList.module.css';

const PriceList = ({
  className,
  selected: initialSelected,
  items,
  onClick,
  hideOptionsWhenSelected,
  selectedIsBigText,
  changeSelectionText,
  allowDeselect,
  linkButtonText,
  linkButton,
}) => {
  const [selected, setSelected] = useState(initialSelected);
  const hasSelectedItem = Number.isInteger(selected);
  const [dontHideSelected, setDontHideSelected] = useState(false);

  const hideOptions = hideOptionsWhenSelected && !dontHideSelected;

  const resetSelection = () => {
    setSelected(null);
  };

  const classes = classNames(
    Root,
    {
      [BigTextSelected]: selectedIsBigText,
      [HideOptionsWhenSelected]: hideOptions,
      [HasSelectedItem]: hasSelectedItem,
    },
    className
  );
  const clicked = (value, isDisabled) => {
    if (isDisabled) return;
    if (value === selected) {
      if (allowDeselect) {
        resetSelection();
      }
      return;
    }
    setSelected(value);
    onClick(value);
  };

  return (
    <div className={classes}>
      {items?.map(
        (
          {
            name,
            description,
            right,
            label,
            value,
            className: itemClassName,
            isDisabled,
          },
          index
        ) => {
          const overrideValue = value ?? toNumber(index);

          return (
            <div
              key={JSON.stringify(name + right)}
              onClick={() => clicked(overrideValue, isDisabled)}
              onKeyPress={() => clicked(overrideValue, isDisabled)}
              role="button"
              tabIndex={0}
              className={classNames(
                ListItem,
                {
                  [ListItemSelected]: overrideValue === selected,
                  [DisabledProduct]: isDisabled,
                },
                itemClassName,
                { [ListItem.isDisabled]: DisabledProduct }
              )}
            >
              <div className={ListItemTop}>
                <div className={ListItemOption}>
                  <div className={Radio} />
                </div>
                <div className={ListItemName}>
                  {name}
                  {label && !hideOptions ? (
                    <Label className={LabelClass}>{label}</Label>
                  ) : null}
                </div>
                <div className={ListItemRight}>{right}</div>
              </div>

              {description && hasSelectedItem ? (
                <div className={ListItemDescription}>{description}</div>
              ) : null}
            </div>
          );
        }
      )}
      {hideOptions && hasSelectedItem && (
        <Button
          onClick={() => {
            if (allowDeselect) {
              resetSelection();
            } else {
              setDontHideSelected(true);
            }
          }}
          className={ChangeSelectionButton}
          appearance="white"
          fullWidth
        >
          {changeSelectionText}
        </Button>
      )}
      {linkButtonText && (
        <Button
          onClick={() => linkButton()}
          className={ChangeSelectionButton}
          appearance="white"
          fullWidth
        >
          {linkButtonText}
        </Button>
      )}
    </div>
  );
};

PriceList.defaultProps = {
  onClick: () => {},
  hideOptionsWhenSelected: false,
  selectedIsBigText: false,
  changeSelectionText: 'Change',
  allowDeselect: false,
};

PriceList.propTypes = {
  onClick: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      right: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      description: PropTypes.string,
      isPopular: PropTypes.bool,
    })
  ).isRequired,
  hideOptionsWhenSelected: PropTypes.bool,
  selectedIsBigText: PropTypes.bool,
  changeSelectionText: PropTypes.string,
  allowDeselect: PropTypes.bool,
};

export default PriceList;
